/**
 * ================================================================================
 * UTILITÁRIO: formatCurrency.js
 * PROPÓSITO: Formatação monetária centralizada (padrão angolano 1.000,00 Kz)
 * ================================================================================
 */

const CURRENCY_SYMBOLS = {
  AOA: 'Kz',
  USD: '$',
  EUR: '€',
  GBP: '£',
  BRL: 'R$',
  ZAR: 'R',
  CNY: '¥',
};

/**
 * Formata valores monetários no padrão angolano
 * @param {number} value - Valor numérico
 * @param {string} currency - Código da moeda (default: AOA)
 * @param {boolean} showSymbol - Mostrar símbolo da moeda
 * @returns {string} Valor formatado
 */
export function formatCurrency(value, currency = 'AOA', showSymbol = true) {
  if (value === null || value === undefined) return '—';

  const absValue = Math.abs(value);
  const formatted = absValue.toLocaleString('pt-AO', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const symbol = CURRENCY_SYMBOLS[currency] || currency;
  const sign = value < 0 ? '-' : '';

  return showSymbol ? `${sign}${formatted} ${symbol}` : `${sign}${formatted}`;
}

/**
 * Formato compacto para valores grandes (ex: 1.2M, 350K)
 */
export function formatCompact(value) {
  if (Math.abs(value) >= 1_000_000) {
    return (value / 1_000_000).toFixed(1) + 'M';
  }
  if (Math.abs(value) >= 1_000) {
    return (value / 1_000).toFixed(0) + 'K';
  }
  return value.toFixed(0);
}

/**
 * Calcula variação percentual
 */
export function calcChange(current, previous) {
  if (!previous || previous === 0) return null;
  return ((current - previous) / Math.abs(previous) * 100).toFixed(1);
}

export { CURRENCY_SYMBOLS };
